module.exports = "/assets/data/2641104990e0bb3ba246c3f9aca5f092-DN2.data.json";